// extracted by mini-css-extract-plugin
export default {"homeContainer":"HomeScreen_homeContainer__yCYnq","homeChild":"HomeScreen_homeChild__ujxPi"};